import { MethodCanvas } from "./MethodCanvas.jsx";
import { CoursePlans } from "./CoursePlans.jsx";
import { LandingHeader } from "./LandingHeader.jsx";
import { OrganizationsSection } from "./OrganizationsSection.jsx";
import { OrientationSection } from "./OrientationSection.jsx";
import { Icon } from "../Icon.jsx";
import { SiteFooter } from "../SiteFooter.jsx";
import {
  XAI_SCHOOL_LINKS,
  caseStages,
  transformationRows,
} from "../../data/consultantCourse.js";

const proofItems = [
  ["globe", "Online"],
  ["briefcase", "Casi pratici"],
  ["document", "Artefatti riutilizzabili"],
  ["certificate", "Attestato XAISchool"],
];

const portfolio = [
  ["Brief cliente", "Obiettivo, contesto e criteri"],
  ["Workflow verificato", "Passaggi, controlli e responsabilità"],
  ["Manuale di utilizzo", "Limiti, test e prossime revisioni"],
];

const finalEvidence = [
  "Brief cliente",
  "Output revisionato",
  "Registro delle verifiche",
  "Metodo riutilizzabile",
];

export function ConsultantLanding() {
  return (
    <div className="landing-shell">
      <LandingHeader />

      <main id="inizio">
        <section className="landing-hero">
          <div className="landing-hero__copy">
            <h1>Il Consulente <em>AI</em> sei tu.</h1>
            <p>
              Impara a dirigere GPT e Claude nel lavoro con i clienti: dal brief alla verifica,
              senza delegare il tuo giudizio.
            </p>
            <div className="landing-actions">
              <a className="button button--coral" href={XAI_SCHOOL_LINKS.assessment}>
                Valuta il tuo livello <Icon name="arrow" size={18} />
              </a>
              <a className="button button--outline" href={XAI_SCHOOL_LINKS.pricing}>
                Vedi piani e prezzi <Icon name="arrow" size={18} />
              </a>
            </div>
            <div className="proof-rail" aria-label="Caratteristiche del percorso">
              {proofItems.map(([icon, label]) => (
                <div key={label}><Icon name={icon} size={25} /><span>{label}</span></div>
              ))}
            </div>
          </div>
          <MethodCanvas />
        </section>

        <section className="method-intro" id="metodo">
          <h2>Un metodo in cinque passi.</h2>
          <p>Un flusso strutturato che mette l’AI al servizio della tua competenza, in ogni fase del progetto.</p>
        </section>

        <OrientationSection />

        <section className="transformation-section page-section">
          <div className="section-index" aria-hidden="true"><span>01</span><i /></div>
          <div className="transformation-layout">
            <div>
              <h2>Un consulente migliore,<br />non un consulente sostituito.</h2>
              <p className="section-lead">
                Il valore non è ottenere una risposta. È saper dirigere, verificare e trasformare
                l’AI in un metodo di lavoro.
              </p>
              <div className="transformation-table">
                {transformationRows.map(([before, after]) => (
                  <div className="transformation-row" key={before}>
                    <strong>{before}</strong>
                    <Icon name="arrow" size={18} />
                    <span>{after}</span>
                  </div>
                ))}
              </div>
            </div>
            <aside className="portfolio-preview" aria-label="Artefatti prodotti durante il percorso">
              <p>Ciò che porterai con te</p>
              {portfolio.map(([title, description], index) => (
                <article key={title}>
                  <div className={`portfolio-sheet portfolio-sheet--${index + 1}`} aria-hidden="true">
                    <span /><i /><i /><i />
                  </div>
                  <div><strong>{title}</strong><span>{description}</span></div>
                </article>
              ))}
            </aside>
          </div>
        </section>

        <CoursePlans />

        <section className="case-section page-section">
          <div className="case-section__main">
            <div className="section-index" aria-hidden="true"><span>03</span><i /></div>
            <h2>Allenati su casi che<br />assomigliano ai tuoi clienti.</h2>
            <p>
              Incarichi realistici, dati e vincoli veri, feedback strutturato. Non impari formule
              magiche: costruisci un metodo trasferibile nel tuo lavoro.
            </p>
            <div className="case-rail">
              {caseStages.map((stage, index) => (
                <article key={stage.title}>
                  <span>{stage.number}</span>
                  <strong>{stage.title}</strong>
                  <p>{stage.description}</p>
                  {index < caseStages.length - 1 ? <Icon name="arrow" size={18} /> : null}
                </article>
              ))}
            </div>
          </div>
          <aside className="final-evidence">
            <h3>La prova finale</h3>
            {finalEvidence.map((item) => (
              <div key={item}><Icon name="check" size={19} /><span>{item}</span></div>
            ))}
          </aside>
        </section>

        <OrganizationsSection />

        <section className="closing-cta" id="inizia">
          <div>
            <h2>Partiamo dal tuo modo di lavorare.</h2>
            <p>
              Il test XAISchool individua il livello adatto e ciò che non hai bisogno di ripetere.
              È gratuito e non richiede email o telefono.
            </p>
            <div className="landing-actions">
              <a className="button button--coral" href={XAI_SCHOOL_LINKS.assessment}>
                Valuta il tuo livello <Icon name="arrow" size={18} />
              </a>
              <a className="button button--light-outline" href={XAI_SCHOOL_LINKS.pricing}>
                Vedi piani e prezzi <Icon name="arrow" size={18} />
              </a>
            </div>
            <small>Percorso online · Starter, Advanced e Premium</small>
          </div>
          <div className="closing-cta__mark" aria-hidden="true">XAI</div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}
